import { render } from "./AdminWeb.vue?vue&type=template&id=31b57462&scoped=true&ts=true"
import script from "./AdminWeb.vue?vue&type=script&lang=ts"
export * from "./AdminWeb.vue?vue&type=script&lang=ts"

import "./AdminWeb.vue?vue&type=style&index=0&id=31b57462&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b57462"]])

export default __exports__